import { useState, type ReactNode } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

interface ExportButtonProps {
  onExport: () => void | Promise<void>;
  label?: ReactNode;
  className?: string;
  disabled?: boolean;
  size?: "default" | "lg";
  testId?: string;
}

export default function ExportButton({
  onExport,
  label = "Export",
  className,
  disabled,
  size = "lg",
  testId,
}: ExportButtonProps) {
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      await onExport();
    } catch (error) {
      toast.error(error instanceof Error ? error.message : "Export failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      type="button"
      variant="dashboardOutline"
      size={size}
      className={className}
      disabled={disabled}
      loading={busy}
      onClick={run}
      data-testid={testId}
    >
      <Download data-icon="inline-start" /> {label}
    </Button>
  );
}
